export { default } from './IssuePanelInfo';
